import 'angular';
import template from './report_timeline.template.html?raw';

const controller = function() {
  const that = this;

  that.getAnnouncedDateLabel = () => {
    let result = 'Announced on';

    if(that.report.type === 'contract') {
      result = 'Awarded at';
    } else if(that.report.type === 'shortlist') {
      result = 'Shortlisted at';
    }

    return result;
  };

  that.displayAnnouncedDate = () => {
    let result = true;

    if(!that.report.announced_date ||
      that.report.type === 'funding_info' ||
      that.report.announced_date === that.report.deadline) {
      result = false;
    }

    return result;
  };
};

angular
  .module('fundingSearchApp.directives.reportTimeline', [])
  .run(['$templateCache', $templateCache => {
    $templateCache.put(template, template);
  }])
  .directive('reportTimeline', () => ({
    restrict: 'E',
    templateUrl: template,
    scope: {
      report: '=',
      isExpandedView: '='
    },
    bindToController: true,
    controller,
    controllerAs: 'vm'
  }));
